import React, { Component } from 'react'
import { Table } from 'antd'
import * as stuff from './columns'

export default class ExplosiveInv extends Component {
	constructor(){
		super();
		this.state = {

		}
	}
  render() {
		var listData = [];
		for (let i = 0; i < this.props.explosives.length; i++) {
			const explosives = this.props.explosives[i];
			if (explosives.form_values['cf08']) {
				if (explosives.form_values['53d7']) {
					var drilltecJobNo = explosives.form_values['53d7'];				
				} else {drilltecJobNo = ''}
				if (explosives.form_values['a141']) {
					var date = explosives.form_values['a141'];
				} else {date = ''}
				for (let k = 0; k < explosives.form_values['cf08'].length; k++) {
					const entries = explosives.form_values['cf08'][k];
					listData.push({
						'date': date,
						'0': drilltecJobNo,
						'1': entries.form_values['53b4'],
						'2': entries.form_values['2496'],
						'3': entries.form_values['ab29'],
						'4': entries.form_values['db1e'],
						'5': entries.form_values['d745'],
						'6': entries.form_values['ddd1'],
						'7': entries.form_values['8470'],
						'8': entries.form_values['6d18'],
						'id': entries.id
					})
				}
			}
		}
    return this.props.user.role === 'admin' && this.props.user.username === 'Jim Alexander' ?
      <div>
        <h1>Explosive use and inventory</h1>
				<h4 style={{paddingBottom: 10}}>Records saved and inventory info.</h4>

					{/* Use log */}
					<h3 style={{marginLeft: 20}}>Entrys</h3>
					<Table
					pagination={false}
					bordered
					columns={stuff.columnsEntry}
					dataSource={listData}
					rowKey='id'
					size="medium" />
         
        </div>
      :
        <div>
          <h1>Authorised Access Required</h1>
          <h4 style={{paddingBottom: 10}}>
            This page is only allowed for 'admin' users.
          </h4>
        </div>
    
  }
}
